{
  "name": "as-components",
  "private": true,
  "version": "0.16.40",
  "type": "module",
  "main": "./dist/as-components-v0.16.rolling.m.js",
  "exports": {
    ".": {
      "types": "./src/exports.ts",
      "import": "./dist/as-components-v0.16.rolling.m.js"
    },
    "./readme": {
      "import": "./README.md",
      "types": "./README.md",
      "source": "./README.md"
    },
    "./as-components-v0.16.rolling.m.js": {
      "default": "./dist/as-components-v0.16.rolling.m.js"
    },
    "./as-components.css": {
      "default": "./dist/as-components.css"
    }
  },
  "scripts": {
    "dev": "vite",
    "build": "vite build && vite build --mode development",
    "build:dev": "vite build --mode development",
    "build:min": "MINIFY=true vite build",
    "preview": "vite preview",
    "build:app": "vite build && vite build --config vite.config.app.ts --",
    "build:test": "vite build && vite build --config vite.config.test.ts",
    "test": "vitest run --project node",
    "test:browser": "vitest run --project browser",
    "test:all": "vitest run",
    "test:watch": "vitest --project node"
  },
  "devDependencies": {
    "@custom-elements-manifest/analyzer": "^0.10.4",
    "@types/mithril": "^2.2.7",
    "@types/node": "^22.13.10",
    "@vitest/browser": "4.1.9",
    "@vitest/browser-playwright": "4.1.9",
    "happy-dom": "^20.10.6",
    "lightningcss": "^1.30.1",
    "playwright": "^1.61.1",
    "terser": "^5.39.0",
    "tsup": "^8.5.1",
    "typescript": "~5.7.3",
    "vite": "^8.0.0",
    "vitest": "4.1.9"
  },
  "dependencies": {
    "@floating-ui/dom": "^1.7.2",
    "fflate": "^0.8.2",
    "idb": "^8.0.2",
    "lodash": "^4.17.21",
    "three-mf": "^1.1.0"
  }
}
